var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.currentPc == true)?[_c('pcpage')]:(_vm.currentMoblie == true)?[_c('mobliepage',{attrs:{"deviceType":_vm.moblieDeviceType}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }